/* eslint-disable one-var */
import util from './util'
import Animations from './animations'
import DataCenter from '@/utils/data-center'

let alertObj, confirmObj, loadingObj, succObj, warnObj, tipsObj
let lang = DataCenter.get('lang')

let langMap
try {
  langMap = require(`../locales/${lang}.json`)
} catch (err) {
  langMap = require('../locales/zh-cn.json')
}

class Dialog {
  constructor (cfg) {
    let container = document.createElement('div'),
      wall = '<div id="d-wall" class="didi-dialog-wall"></div>',
      wrap =
        '<div id="d-wrap" class="didi-dialog-wrap">' +
        '<div id="d-content" class="didi-dialog-content">' +
        '</div>' +
        '</div>'

    container.setAttribute('id', 'd-container')
    container.setAttribute('class', 'didi-dialog-container')
    container.innerHTML = wall + wrap

    this.cfg = cfg
    this.container = container
    this.wall = container.querySelector('#d-wall')
    this.wrap = container.querySelector('#d-wrap')
    this.content = container.querySelector('#d-content')
    this.addParts()
  }

  addParts () {
    // 可以为dialog增加一个特殊标志属性，以便根据该属性来控制样式
    if (this.cfg.styleType) {
      this.container.setAttribute(this.cfg.styleType, '')
    }
    if (this.cfg.tag) {
      this.container.setAttribute(this.cfg.tag, '')
    }
    if (this.cfg.icon !== false) {
      this.addIcon()
    }
    if (this.cfg.title) {
      this.addTitle()
    }
    if (this.cfg.desc) {
      this.addDesc()
    }
    if (this.cfg.close) {
      this.addClose()
    }
    if (this.cfg.btns !== false) {
      this.addButts()
    }
  }

  addIcon () {
    let icon = '<div class="didi-dialog-icon">', img

    if (this.cfg.icon === false) {
      return false
    } else if (typeof this.cfg.icon === 'string' &&
      this.cfg.icon.match(/^https?:/)) {
      // url方式
      img = '<img src="' + this.cfg.icon + '"/>'
      icon += img
    } else if (typeof this.cfg.icon === 'string') {
      // 标签方式
      icon += this.cfg.icon
    } else {
      // 背景图方式
    }
    icon += '</div>'
    this.content.innerHTML += icon
  }

  addClose () {
    let close = document.createElement('div')
    close.setAttribute('class', 'didi-dialog-close')
    this.content.appendChild(close)
    let self = this
    setTimeout(() => {
      // eslint-disable-next-line no-unused-vars
      util.tap(close, function (e) {
        self.cfg.closeCallBack()
      }, 'active')
    }, 0)
  }

  addTitle () {
    let title = '<div class="didi-dialog-title">'

    if (!this.cfg.title) {
      return false
    } else if (typeof this.cfg.title === 'string') {
      title += this.cfg.title
    }
    title += '</div>'
    this.content.innerHTML += title
  }

  addDesc () {
    let desc = '<div class="didi-dialog-desc">'

    if (!this.cfg.desc) {
      return false
    } else if (typeof this.cfg.desc === 'string') {
      desc += this.cfg.desc
    }
    desc += '</div>'
    this.content.innerHTML += desc
  }

  addButts () {
    let btns = this.cfg.btns, butts
    if (Array.isArray(btns) && btns.length > 0) {
      butts = document.createElement('div')
      butts.setAttribute('class', 'didi-dialog-butts')
      console.log(this.cfg)
      if (this.cfg.buttonType === 'column') {
        butts.className = butts.className + ' column'
      }
      // eslint-disable-next-line no-unused-vars
      btns.forEach(function (btn, idx) {
        let butt = document.createElement('div')
        btn.id && butt.setAttribute('id', btn.id)
        btn.kls && butt.setAttribute('class', btn.kls)
        butt.innerHTML = btn.text || ''
        butts.appendChild(butt)
        if (typeof btn.callback === 'function') {
          setTimeout(() => {
            util.tap(butt, function (e) {
              // this指向butt
              btn.callback.call(this, e)
            }, 'active')
          }, 0)
        }
      })
      this.content.appendChild(butts)
    }
  }

  show (animate, cb) {
    document.body.appendChild(this.container)
    if (animate && typeof animate.show === 'function') {
      animate.show.call(this, cb)
    }
  }

  hide (animate, cb) {
    if (animate && typeof animate.hide === 'function') {
      animate.hide.call(this, cb)
    } else {
      setTimeout(() => {
        util.remove(this.container)
      }, 100)
    }
  }
}

// 每个组件单独实现，更好单独控制
// alert
let alert = function (opt) {
  alertObj && alertObj.hide()
  if (opt !== false) {
    let cfg, animate
    cfg = {
      desc: opt.desc,
      title: opt.title,
      animateType: opt.animateType || 'pop',
      tag: opt.tag,
      icon: opt.icon,
      timeout: opt.timeout,
      styleType: opt.styleType,
      btns: opt.btns || [
        {
          id: 'd-btn-ok',
          kls: 'didi-dialog-btn-ok',
          text: opt.text || langMap.common_got_it,
          callback: function (e) {
            e.stopPropagation()
            e.preventDefault()
            alertObj.hide(animate)
            typeof opt.callback === 'function' && opt.callback.call(this, e)
          }
        }]
    }

    alertObj = new Dialog(cfg)
    animate = Animations[alertObj.cfg.animateType]
    alertObj.container.setAttribute('dialog-type', 'alert')
    alertObj.show(animate)

    // 自动关闭
    if (typeof cfg.timeout === 'number') {
      setTimeout(function () {
        alertObj.hide(animate)
      }, cfg.timeout)
    }
  }
}

// confirm
let confirm = function (opt) {
  confirmObj && confirmObj.hide()
  if (opt !== false) {
    let cfg, animate

    cfg = {
      title: opt.title,
      desc: opt.desc,
      animateType: opt.animateType || 'pop',
      tag: opt.tag,
      icon: opt.icon === undefined ? true : opt.icon,
      close: opt.close === undefined ? false : opt.close,
      buttonType: opt.buttonType,
      styleType: opt.styleType,
      closeCallBack: function () {
        confirmObj.hide(animate)
      },
      timeout: opt.timeout,
      btns: opt.btns || [
        {
          id: 'd-btn-cancel',
          kls: 'didi-dialog-btn-cancel',
          text: opt.cancelText || langMap.common_cancel,
          callback: function (e) {
            e.stopPropagation()
            e.preventDefault()
            confirmObj.hide(animate)
            typeof opt.cancelCallback === 'function' &&
            opt.cancelCallback.call(this, e)
          }
        }, {
          id: 'd-btn-ok',
          kls: 'didi-dialog-btn-ok',
          text: opt.confirmText || langMap.common_confirm,
          callback: function (e) {
            e.stopPropagation()
            e.preventDefault()
            confirmObj.hide(animate)
            typeof opt.confirmCallback === 'function' &&
            opt.confirmCallback.call(this, e)
          }
        }]
    }

    confirmObj = new Dialog(cfg)
    animate = Animations[confirmObj.cfg.animateType]
    confirmObj.container.setAttribute('dialog-type', 'confirm')
    confirmObj.show(animate)

    if (typeof cfg.timeout === 'number') {
      setTimeout(function () {
        confirmObj.hide(animate)
      }, cfg.timeout)
    }
  }
}

// loading
let loading = function (opt) {
  loadingObj && loadingObj.hide()
  if (opt !== false) {
    let cfg, animate

    cfg = {
      desc: opt.desc,
      animateType: opt.animateType || 'pop',
      tag: opt.tag,
      icon: opt.icon,
      timeout: opt.timeout || 2000,
      after: opt.after
    }

    loadingObj = new Dialog(cfg)
    animate = Animations[loadingObj.cfg.animateType]
    loadingObj.container.setAttribute('dialog-type', 'loading')
    loadingObj.show(animate)

    if (typeof cfg.timeout === 'number') {
      setTimeout(function () {
        // loading完之后如果需要可回调
        if (typeof cfg.after === 'function') {
          loadingObj.hide(animate, cfg.after)
        } else {
          loadingObj.hide(animate)
        }
      }, cfg.timeout)
    }
  }
}

// success
let success = function (opt) {
  succObj && succObj.hide()
  if (opt !== false) {
    let cfg, animate

    cfg = {
      desc: opt.desc,
      animateType: opt.animateType || 'pop',
      tag: opt.tag,
      icon: opt.icon,
      timeout: opt.timeout || 2000,
      after: opt.after
    }

    succObj = new Dialog(cfg)
    animate = Animations[succObj.cfg.animateType]
    succObj.container.setAttribute('dialog-type', 'success')
    succObj.show(animate)

    if (typeof cfg.timeout === 'number') {
      setTimeout(function () {
        if (typeof cfg.after === 'function') {
          succObj.hide(animate, cfg.after)
        } else {
          succObj.hide(animate)
        }
      }, cfg.timeout)
    }
  }
}

// warn
let warn = function (opt) {
  warnObj && warnObj.hide()
  if (opt !== false) {
    let cfg, animate

    cfg = {
      desc: opt.desc,
      animateType: opt.animateType || 'pop',
      tag: opt.tag,
      icon: opt.icon,
      timeout: opt.timeout || 2000,
      after: opt.after
    }

    warnObj = new Dialog(cfg)
    animate = Animations[warnObj.cfg.animateType]
    warnObj.container.setAttribute('dialog-type', 'warn')
    warnObj.show(animate)

    if (typeof cfg.timeout === 'number') {
      setTimeout(function () {
        if (typeof cfg.after === 'function') {
          warnObj.hide(animate, cfg.after)
        } else {
          warnObj.hide(animate)
        }
      }, cfg.timeout)
    }
  }
}

let tips = function (opt) {
  tipsObj && tipsObj.hide()
  if (opt !== false) {
    let cfg, animate
    cfg = {
      desc: opt.desc,
      animateType: opt.animateType || 'slide',
      tag: opt.tag,
      icon: opt.icon,
      timeout: opt.timeout || 2000,
      after: opt.after
    }

    tipsObj = new Dialog(cfg)
    animate = Animations[tipsObj.cfg.animateType]
    tipsObj.container.setAttribute('dialog-type', 'tips')
    tipsObj.show(animate)

    if (typeof cfg.timeout === 'number') {
      setTimeout(function () {
        if (typeof cfg.after === 'function') {
          tipsObj.hide(animate, cfg.after)
        } else {
          tipsObj.hide(animate)
        }
      }, cfg.timeout)
    }
  }
}

export default {
  alert,
  confirm,
  loading,
  success,
  warn,
  tips
}
